// src/components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Made by me 😊</p>
    </footer>
  );
};

export default Footer;
